import { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import _forEach from 'lodash/forEach';
import _keys from 'lodash/keys';
import _get from 'lodash/get';

import { AppContext, EMPTY_OBJECT } from 'commons-ui';

import useService from '../../../useService';

const useCreate = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert } = useContext(AppContext);
	const history = useHistory();
	const { requestCreateApkVersionInfo, requestUploadApk } = useService();

	const createApkVersionInfo = async (createdData: any) => {
		setShowLoader(true);
		try {
			const formData = new FormData();
			_forEach(_keys(createdData), (key: string) => {
				formData.append(key, createdData[key]);
			});
			const result = await requestUploadApk(formData);
			const apkLinkUrl = _get(result, ['data', 'apkLinkUrl']);

			const createApkFinalData = { ...createdData, apkLinkUrl };

			await requestCreateApkVersionInfo(createApkFinalData);
			showAlert('Apk Version created');
			history.goBack();
		} catch (error: any) {
			showAlert(`Error: ${error.response.data.error}`, { type: 'error' });
		} finally {
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (submittedData: any) => {
		createApkVersionInfo(submittedData);
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data: EMPTY_OBJECT, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useCreate;
